import { DetectBrand } from "../../mixins/brandDetector";
const brandedStore = {
  //MenuDoc: "Menus/{0}/StoreMenus/DefaultMenu",
  StoreMenuDoc: "Menus/{0}/StoreMenus/{1}",
  StoreMenus: "Menus/{0}/StoreMenus/",
  MenuDoc: "Menus/{0}/",
  StoreCollection: "Stores",
  Users: "Users",
  UserDoc: "Users/{0}",
  GuestUserDoc: "GuestUsers",
  OrderHistoryDoc: "OnlineOrdersInfo/{0}/HistoryOrders/{1}",
  HistoryOrdersCollection: "OnlineOrdersInfo/{0}/HistoryOrders/",
  TrackingOrderDoc: "OnlineOrdersInfo/{0}/TrackingOrders/{1}",
  TrackingOrderCollection: "OnlineOrdersInfo/{0}/TrackingOrders/",
  BasicDoc: "BasicInformation/Basic",
  MessageTemplateCollection: "Stores/{0}/MessageTemplates",
  PriceTriggersDoc: "Menus/{0}/",
  BlackoutDatesCollection: "OnlineOrderingModule/{0}/",
  ProductStatus: "/Menus/{0}/ProductStatus"
};
const generalStore = {
  StoreMenus: "OnlineOrderingModule/{0}/Menus/",
  MenuDoc: "OnlineOrderingModule/{0}/",
  StoreCollection: "OnlineOrderingModule",
  Users: "Users",
  UserDoc: "Users/{0}",
  GuestUserDoc: "OnlineOrderingModule/{0}/GuestUsers/",
  HistoryOrdersCollection: "OnlineOrderingModule/{0}/HistoryOrders/",
  OrderHistoryDoc: "OnlineOrderingModule/{0}/HistoryOrders/{1}",
  TrackingOrderCollection: "OnlineOrderingModule/{0}/TrackingOrders/",
  TrackingOrderDoc: "OnlineOrderingModule/{0}/TrackingOrders/{1}",
  PriceTriggersDoc: "OnlineOrderingModule/{0}/",
  BasicDoc: "",
  MessageTemplateCollection: "?",
  BlackoutDatesCollection: "OnlineOrderingModule/{0}/",
  ProductStatus: "OnlineOrderingModule/{0}/ProductStatus"
};

export const paths = DetectBrand.methods.isBranded()
  ? brandedStore
  : generalStore;
